<div id="consumption-emission-chart" inViewport (inViewportAction)="load($event.visible)">
  <sesio-loader @fadeOut></sesio-loader>
</div>
